<template>
  <div class="corporate-dashboard container">

    <div v-if="corporate">
      <h3>B2B Admin Dashboard ({{ corporate }})</h3>
    </div>

    <div class="corporate-dashboard-total-users">
      <!-- <h4 class="mb-3">Users</h4> -->
      <div class="row">

        <div class="col-md-3 col-lg-2 col-sm-6 col-xs-12 mb-3 responsive-users-card">
          <div class="card total-user-card rounded">
            <div class="card-body">
              <div class="info-card-title font-weight-bold">
                Total Users
              </div>
              <div class="value font-weight-bold" v-if="!isLoading">
                {{ totalUsers }}
              </div>
              <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="corporate-dashboard-header mt-3" v-if="showFilters">
      <b-row>
        <b-col cols=12 md=auto class="pr-0 mt-3 px-md-3">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'fromDate'">From</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <b-form-datepicker
                  :date-format-options="dateFormatOption"
                  :min="minFromDate"
                  :max="maxFromDate"
                  class="filter-date-input-white notranslate"
                  :id="'fromDate'" type="date"
                  v-model="fromDate">
              </b-form-datepicker>
            </div>
          </div>
        </b-col>
        <b-col cols=12 md=auto class="pr-0 mt-3 px-md-3">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'toDate'">To</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <b-form-datepicker
                  :date-format-options="dateFormatOption"
                  :min="minToDate"
                  :max="maxToDate"
                  class="filter-date-input-white notranslate"
                  :id="'toDate'" type="date"
                  v-model="toDate">
              </b-form-datepicker>
            </div>
          </div>
        </b-col>
        <b-col cols=12 md=auto class="pr-0 mt-3 px-md-3">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'teams'">Teams</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <multiselect
                  v-model="selectedTeams"
                  :options="allTeams"
                  track-by="id"
                  label="name"
                  placeholder="Select teams"
                  title="Select teams which you want to display"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :allow-empty="true"
                  :showLabels="false"
                  @input="updateUsersFilter">
              </multiselect>
            </div>
          </div>
        </b-col>
        <b-col cols=12 md=auto class="pr-0 mt-3 px-md-3">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'teams'">Users</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <multiselect
                  v-model="selectedUsers"
                  :options="selectedTeamUsers"
                  track-by="id"
                  label="name"
                  placeholder="Select users"
                  title="Select users which you want to display"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :showLabels="false"
                  :allow-empty="true">
              </multiselect>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row cols=12 class="mt-4 mr-lg-5 d-flex flex-row-reverse">
        <b-col md=6 lg=2 sm=6 xs=12>
          <button class="btn btn-outline-success ef-btn ef-btn-banner w-100" @click="applyFilter">Apply Filter</button>
        </b-col>
        <b-col md=6 lg=2 sm=6 xs="12" class="clear-filter">
          <button v-if="showClearFilter" class="btn btn-outline-success ef-btn ef-btn-banner w-100" @click="clearFilter">Clear Filter</button>
        </b-col>
      </b-row>
    </div>

    <div class="corporate-dashboard-active-users mt-5">
      <div class="row">

        <div class="col-sm-12 col-md-3 col-lg-2 mb-3">
          <div class="card border-card">
            <div class="card-body">
              <div class="info-card-title">
                Active Users
                <div class="i-border text-dark notranslate" id="active-users">i</div>
              </div>

              <b-tooltip
                  custom-class="custom-tooltip"
                  target="active-users"
                  title="Tooltip title">
                Minimum 1 workout completed.
              </b-tooltip>

              <div class="value" v-if="!isLoading">
                {{ filteredActiveUsers }}
              </div>
              <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-3 mb-3">
          <div class="card border-card">
            <div class="card-body">
              <div class="info-card-title">
                Workout duration
              </div>
              <div class="value" v-if="!isLoading">
                {{ (showTotal.workoutsDuration.value)? total.workoutsDuration : workoutsDuration }}
              </div>
              <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              <div class="message">
                <multiselect
                    class="card-select"
                    v-model="showTotal.workoutsDuration"
                    :options="showTotalSelectOption"
                    track-by="value"
                    label="label"
                    :multiple="false"
                    :select-label="''"
                    :deselect-label="''"
                    :allow-empty="false">
                </multiselect>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-3 mb-3">
          <div class="card border-card">
            <div class="card-body">
              <div class="info-card-title">
                Workouts completed
              </div>
              <div class="value" v-if="!isLoading">
                {{ (showTotal.workoutsCompleted.value)? total.workoutsCompleted : workoutsCompleted }}
              </div>
              <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              <div class="message">
                <multiselect
                    class="card-select"
                    v-model="showTotal.workoutsCompleted"
                    :options="showTotalSelectOption"
                    track-by="value"
                    label="label"
                    :multiple="false"
                    :select-label="''"
                    :deselect-label="''"
                    :allow-empty="false">
                </multiselect>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-3" v-if="!disableCalories">
          <div class="card border-card">
            <div class="card-body">
              <div class="info-card-title">
                Calories Burnt
              </div>
              <div class="value" v-if="!isLoading">
                {{ (showTotal.caloriesBurnt.value)? total.caloriesBurnt : caloriesBurnt }}
              </div>
              <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              <div class="message">
                <multiselect
                    class="card-select"
                    v-model="showTotal.caloriesBurnt"
                    :options="showTotalSelectOption"
                    track-by="value"
                    label="label"
                    :multiple="false"
                    :select-label="''"
                    :deselect-label="''"
                    :allow-empty="false">
                </multiselect>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="corporate-dashboard-charts mt-2 mt-md-5" v-if="showGraph && !isLoading">
      <div class="row">

        <div class="col-md-12 mb-5" v-if="totalCharts.length">
          <div class="card h-auto">
            <div class="card-body">
              <div class="col-10 col-md-3 info-card-title mb-3 ml-4">
                <multiselect
                    class="d-inline-block ml-2 card-select"
                    v-model="totalChartSelected"
                    :options="totalCharts"
                    track-by="index"
                    label="chartLabel"
                    :multiple="false"
                    :select-label="''"
                    :deselect-label="''"
                    :allow-empty="false">
                </multiselect>
              </div>
              <div v-for="data in totalCharts" :key="data.index">
                <div v-if="data.index === totalChartSelected.index">
                  <line-chart :chart-data="data" :options="options"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-5" v-if="dailyObservationCharts.length">
          <div class="card h-auto">
            <div class="card-body">
              <div class="col-10 col-md-4 info-card-title mb-3 ml-4">
                <multiselect
                    class="d-inline-block ml-2 card-select"
                    v-model="dailyObservationChartSelected"
                    :options="dailyObservationCharts"
                    track-by="index"
                    label="chartLabel"
                    :multiple="false"
                    :select-label="''"
                    :deselect-label="''"
                    :allow-empty="false">
                </multiselect>
              </div>
              <div v-for="data in dailyObservationCharts" :key="data.index">
                <div v-if="data.index === dailyObservationChartSelected.index">
                  <bar-chart :chart-data="data" :options="options"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import b2bService from '@/module_user/api/b2b-service';
import Multiselect from 'vue-multiselect';
import LineChart from "@/module_user/components/LineChart";
import BarChart from "@/module_user/components/BarChart";

const { mapActions: b2bActions } = createNamespacedHelpers(
    "b2bUser"
);

export default {
  name: "HomeManagementDashboard",
  data() {
    const statsSelectOption = [
      { value: 0, label: 'Average per active user' },
      {value: 1, label: 'Total'}
    ];
    return {
      corporate: '',
      showFilters: true,
      showGraph: true,
      isLoading: false,
      total: {
        noOfWorkouts: "--",
        workoutsDuration: "--",
        workoutsCompleted: "--",
        caloriesBurnt: "--"
      },
      showTotal: {
        noOfWorkouts: statsSelectOption[0],
        workoutsDuration: statsSelectOption[0],
        workoutsCompleted: statsSelectOption[0],
        caloriesBurnt: statsSelectOption[0]
      },
      showTotalSelectOption: statsSelectOption,
      totalUsers: "--",
      activeUsers: "--",
      filteredActiveUsers: "--",
      noOfWorkouts: "--",
      workoutsDuration: "--",
      workoutsCompleted: "--",
      caloriesBurnt: "--",
      fromDate: '',
      toDate: '',
      minFromDate: undefined,
      maxFromDate: undefined,
      minToDate: undefined,
      maxToDate: undefined,
      dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
      allTeams: [],
      selectedTeams: [],
      allUsers: [],
      selectedTeamUsers: [],
      selectedUsers: [],
      totalCharts: [],
      totalChartSelected: {},
      dailyObservationCharts: [],
      dailyObservationChartSelected: {},
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
    }
  },
  components: {
    Multiselect,
    LineChart,
    BarChart
  },
  watch: {
    fromDate: function (val) {
      this.minToDate =  new Date(val);
    },
    toDate: function (val) {
      this.maxFromDate = new Date(val);
    },

  },
  computed: {
    showClearFilter() {
      if ((this.fromDate || this.toDate) || this.selectedTeams || this.selectedUsers) {
        return (this.fromDate !== '' || this.toDate !== '') || this.selectedTeams?.length || this.selectedUsers?.length;
      }
    },
    disableCalories(){
      return this.$store?.state?.userInfo?.corporate?.config?.disableCalories ?? false
    }
  },
  methods: {
    ...b2bActions(["setIsTitle", "setTitle"]),
    loadCharts(graphsData) {
      this.totalCharts = [];
      this.dailyObservationCharts = [];
      if (graphsData.totalCharts) {
        graphsData.totalCharts.forEach((chart, index) => {
          this.totalCharts.push(this.getChartData(
              chart.chartLabel,
              chart.labels,
              chart.dataPoints,
              '#73bc44',
              undefined,
              index
          ));
        });
      }
      if (graphsData.dailyObservationCharts) {
        graphsData.dailyObservationCharts.forEach((chart, index) => {
          this.dailyObservationCharts.push(this.getChartData(
              chart.chartLabel,
              chart.labels,
              chart.dataPoints,
              '#73bc44',
              '#73bc44',
              index
          ));
        });
      }
      this.totalChartSelected = this.totalCharts[0];
      this.dailyObservationChartSelected = this.dailyObservationCharts[0];
    },
    getChartData(chartLabel, labels, dataPoints, borderColor, backgroundColor, index) {
      return {
        index,
        chartLabel,
        labels: labels,
        datasets: [
          {
            label: chartLabel,
            data: dataPoints,
            borderColor: borderColor,
            backgroundColor: backgroundColor,
            tension: 0.4
          },
        ]
      }
    },
    loadDashboard(filters) {
      this.isLoading = true;
      this.corporate = this.$route.params?.corporate;
      b2bService.getCorporateDashboard({ filters, corporate: this.corporate }).then((resp) => {
        if (resp.code === 200) {
          const data = resp.data;
          this.loadCharts(data?.graphsData);
          this.totalUsers = data.totalUsers;
          this.activeUsers = data.activeUsers;
          this.filteredActiveUsers = data.filteredActiveUsers;
          this.noOfWorkouts = data.noOfWorkouts;
          this.workoutsDuration = data.workoutsDuration;
          this.workoutsCompleted = data.workoutsCompleted;
          this.caloriesBurnt = data.caloriesBurnt;
          this.allTeams = data.allTeams;
          this.allUsers = data.allUsers;
          this.selectedTeamUsers = data.allUsers;
          this.total = data.total;
        }
        this.isLoading = false;
      }).catch(error => {
        this.makeToast("danger", "Failed to load the dashboard")
      }).finally(() => {
        this.isLoading = false;
      });
      this.loadLocalConfig(true);
    },
    async applyFilter() {
      const selectedTeams = [];
      this.selectedTeams?.forEach((team) => {
        selectedTeams.push(team.id);
      });

      const selectedUsers = [];
      this.selectedUsers?.forEach((user) => {
        selectedUsers.push(user.id);
      });
      const filters = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        selectedTeams: selectedTeams,
        selectedUsers: selectedUsers
      }

      this.loadDashboard(filters);
    },
    // Updating users filter as per team selection
    async updateUsersFilter() {
      let tempUsersList = [];
      this.selectedTeams.forEach(team => {
        tempUsersList.push(...(this.allUsers.filter(user => user.access_code === team.id)));
      });
      this.selectedTeamUsers = tempUsersList;
    },
    async clearFilter() {
      this.fromDate = '';
      this.toDate = '';
      this.selectedTeams = [];
      this.selectedUsers = [];
      this.applyFilter();
    },
    makeToast(variant = null, content) {
      this.$bvToast.toast(content, {
        title: "Message",
        variant: variant,
        solid: true,

      })
    },

    loadLocalConfig(onlySave = false) {
      try{
        const localConfig = localStorage.getItem('config');
        let config = (localConfig) ? JSON.parse(localConfig) : {};
        if (config?.corporateDashboardFilters?.[this.corporate] && !onlySave) {
          const filters = config.corporateDashboardFilters;
          this.fromDate = filters.fromDate;
          this.toDate = filters.toDate;
          this.selectedTeams = filters.selectedTeams;
          this.selectedUsers = filters.selectedUsers;
        }
        else {
          config.corporateDashboardFilters = {}
          config.corporateDashboardFilters[this.corporate] = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            selectedTeams: this.selectedTeams ?? [],
            selectedUsers: this.selectedUsers ?? []
          };
        }
        localStorage.setItem('config', JSON.stringify(config));
        const filters = config.corporateDashboardFilters[this.corporate];
        filters.selectedUsers = filters.selectedUsers.map((x) => x.id);
        filters.selectedTeams = filters.selectedTeams.map((x) => x.id);
        return config.corporateDashboardFilters;
      }
      catch(error){
        this.makeToast("danger", "Failed to load filters from local config")
      }
    }
  },
  mounted() {
    this.corporate = this.$route.params?.corporate;
    const filters = this.loadLocalConfig();
    this.loadDashboard(filters);
    this.setIsTitle(true);
    this.setTitle("Dashboard");

  },
  beforeDestroy() {
    this.setIsTitle(false);
    this.setTitle("");
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
::v-deep .multiselect__tags {
  min-height: 0;
  padding: 0;
  background: #FFFFFF !important;
  border: 2px solid #73BC44;
  border-radius: 5px !important;
  min-height: 34px !important;
  min-width: 170px !important;
  flex-direction: column;
  display: flex;
  align-items: center;
}
::v-deep .multiselect__placeholder {
  margin: 5px 0 5px 10px;
  color: #969B92;
  font-weight: 500;
}
::v-deep .text-muted {
  color: #969B92 !important;
  font-weight: 500;
}
::v-deep .multiselect__single {
  margin-bottom: 0px !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #141513 !important;
}
::v-deep .multiselect__select:before {
  color: #73BC44 !important;
  border-color: #73BC44 transparent transparent;
}
::v-deep .multiselect__tags-wrap {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
}
::v-deep .multiselect__tag {
  margin-bottom: 0;
  margin: 4px;
}
.filter-date-input-white {
  height: 34px !important;
  width: auto !important;
}
.ef-btn {
  padding: 5px 10px;
  height: 34px;
  // width: 134px;
  font-size: 14px;
}
.corporate-dashboard {
  text-align: left;
  //color: #f0f0f0;
  h4 {
    font-size: 18px;
    font-weight: bold;
  }
}
.card {
  border: none;
  height: 140px;
  background-color: #ffffff;
  color: #1c1c1c;
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
  .card-body {
    position: relative;
    padding: 1rem;
    .info-card-title {
      color: #41c300;
      font-weight: bold;
    }
    .value {
      font-size: xx-large;
    }
    .message {
      font-size: small;
      position: absolute;
      bottom: 15px;
      width: 85%;
    }
  }
}
.border-card {
  border: 2px solid #969B92 !important;
  background-color: #F4F6F9;
  box-shadow: none;
  color: #141513;
  .card-body {
    .info-card-title {
      color: #969B92;
      font-weight: bold;
      font-size: 12px;
      line-height: 18px;
    }
    .value {
      font-weight: bold;
      font-size: 16px !important;
      line-height: 24px;
    }
  }
}
.total-user-card {
  background-color: #73BC44 !important;
  color: #ffffff !important;
  width: 127px;
  height: 78px;
  .card-body {
    .info-card-title {
      color: #F4F6F9;
      font-size: 12px;
      line-height: 20px;
    }
    padding: 15px 24px;
    .value {
      font-size: 16px;
      line-height: 28px;
      color: #FFFFFF;
    }
  }
}
.active-user-card {
  background-color: #73bc44;
  color: #ffffff;
  .card-body {
    .info-card-title {
      color: #ffffff;
    }
  }
}
.filter-label-col {
  padding: 0 0 0 35px;
}
.filter-label {
  margin: 0;
  padding: 0;
  top: 50%;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #969B92;
}
.card-select {
  background-color: #f7f7f7;
  //color: white;
  border: none;
  margin-left: -3px;
  border-radius: 3px;
  width: 100%;
  &:focus-visible {
    outline: none;
  }
}
.i-border {
  border: 1px solid #73BC44;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  text-align: center;
  justify-content: center;
  display: inline-block;
  font-size: 11px;
  color: #fff;
  margin-left: 2px;
  transform: translateY(-2px);
}

@media screen and (max-width: 767.98px) {
  ::v-deep .multiselect__tags {
    padding: 0rem;
    height: auto !important;
    min-height: 35px;
    flex-direction: column;
    align-items: start;
  }

  ::v-deep .multiselect__tag{
    // margin-bottom: 10px;
    margin: 4px;
  }
  
  ::v-deep .multiselect__tags-wrap {
    flex-wrap: wrap !important;
  }

  ::v-deep .multiselect__single {
    font-size: 10px;
  }
  ::v-deep .multiselect__single {
    font-size: 10px;
  }
  .filter-label {
    position: unset !important;
    width: 5%;
  }
  .filter-label-col {
    padding-right: 15px;
    padding-left: 15px;
  }
  .border-card {
    .card-body {
      .info-card-title {
        font-size: 10px;
        line-height: 15px;
      }
      .value {
        font-size: 14px !important;
        line-height: 21px;
      }
    }
  }
  .card-select {
    margin-left: -7px;
  }
  .card {
    height: 125px;
  }

  .responsive-users-card{
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .clear-filter{
    margin-top: 1rem;
  }
}

</style>
